import { render } from "./ChooseSpace.vue?vue&type=template&id=6f9957b4&scoped=true"
import script from "./ChooseSpace.vue?vue&type=script&lang=js"
export * from "./ChooseSpace.vue?vue&type=script&lang=js"

import "./ChooseSpace.vue?vue&type=style&index=0&id=6f9957b4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6f9957b4"

export default script